import { useContext } from 'react'
import { AppContext } from '../../store/AppProvider'
import { Notification } from './Notification'

export const NotificationBanner = () => {
    const { showBanner } = useContext(AppContext)

    return (
        <>
            {showBanner?.map((banner) => <Notification key={banner?.bannerId} bannerDetails={banner} />)}
        </>
    )
}
